<capra-button
  capraTooltip
  [tooltipContent]="state ? 'Remove Output from Report (&#8984;/Ctrl + 2)' : 'Add Output to Report (&#8984;/Ctrl + 1)'"
  [tooltipIsDisabled]="disabled"
  [tooltipPlacement]="toolTipPlacement"
  [tooltipSize]="tooltipSize"
  tooltipDelay="500"
  variant="secondary"
  color="neutral"
  size="small"
  [disabled]="disabled"
  [text]="buttonText"
  (clicked)="toggleReportState()"
>
</capra-button>
